// extracted by mini-css-extract-plugin
module.exports = {"header":"hI","headerBg":"hJ"};